export default "__VITE_ASSET__C8hSiv3p__"